import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Aavtar from '../images/upload-img.png';
import { BASE_URL } from './helper';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Updatepost() {
    const { postId } = useParams(); // Access postId from URL parameter
    const navigate = useNavigate();

    function capitalizeFirstLetter(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    const [post, setPost] = useState({
        title: '',
        description: '',
        imageUrl: '',
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/post/${postId}`); // Fetch data for the postId
                const jsonData = await response.json();
                setPost(jsonData);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [postId]); // Update data when postId changes

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setPost({ ...post, [name]: value });
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const base64 = await convertTobase64(file)
        setPost({ ...post, imageUrl: base64 }); // Update file state
    }

   // ...

   const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
        // Send update request to API with updated post data
        const response = await fetch(`${BASE_URL}/api/updateblog/${postId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ title: capitalizeFirstLetter(post.title), description: post.description, image: post.imageUrl })
        });
        if (response.ok) {
            const json = await response.json();
            console.log(json);
            alert("Your Post is Updated");
            navigate('/');
            
        }
    } catch (error) {
        // Handle fetch error
        console.log("Error updating post:", error);
        alert("Failed to update post. Please try again.");
    }
 };



    return (
        <div>
        <Header/>
        <div className='container cont-1'>
            <h1>Update Post</h1>
            <div>
                <label htmlFor="image-upload" style={{ paddingRight: "10px" }}>Upload Image</label>
                <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                />
            </div>
            <form className="form" onSubmit={handleFormSubmit}>
                <div className="form-group">
                    <img className='cont1-img' name="image" src={post.imageUrl || Aavtar} alt="Uploaded image" />
                    <label>Title</label>
                    <input className="form-control" type="text" name="title" value={post.title || ''} onChange={handleInputChange} />
                    <label>Post</label>
                    <textarea className="form-control" name="description" value={post.description || ''} onChange={handleInputChange} rows="5" cols="30"></textarea>
                </div>
                <button className="btn btn-primary mt-3" type="submit" name="button" >Update</button>
            </form>
        </div>
        <Footer/>
    </div>
    )
}

function convertTobase64(file) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result)
        };
        fileReader.onerror = (error) => {
            reject(error)
        }
    })

}
